import { useMutation } from '@tanstack/react-query';
import type { AIAssistRequest } from 'api/models/AIAssistRequest';
import type { AIAssistResponse } from 'api/models/AIAssistResponse';
import { FirmsService } from 'api/services/FirmsService';

export const useAIAssistValuationsSummary = (firmId: number) =>
  useMutation<AIAssistResponse, Error, AIAssistRequest>({
    mutationFn: data =>
      FirmsService.apiFirmsValuationsDefinitionsAiAssistCreate(String(firmId), data) as Promise<AIAssistResponse>,
  });
